<template>
    <div class="wrapper">
        <div class="top-box">
            <img class="top-img" :data-src="tabList[active_index].img" alt="">
            <div class="top-tab">
                <img class="top-logo" data-src="../../static/img/logo.png" alt="">
                <div class="tab-list">
                    <div class="tab-item" :style="active_index == index ? 'transform: scale(1.1);' : ''" @click="changeTab(index)" v-for="(item,index) in tabList" :key="index">{{item.text}}</div>
                </div>
            </div>
        </div>
        <router-view/>
        <div class="bottom-box">
            <div class="bottom-left">
                <div class="bottom-left-tabs">
                    <div class="bottom-left-tab-item" @click="changeTab(index)" v-for="(item,index) in tabList" :key="index">{{item.text}}</div>
                </div>
                <div class="bottom-left-info">
                    <div class="bottom-left-text1"><a href="https://beian.miit.gov.cn">沪公网备沪ICP备17002979号-16</a> 经营许可证编号：沪B2-20170190  <img src="../../static/img/bottom-icon.png" alt=""></div>
                    <!-- <div class="bottom-left-text2">法律顾问：上海锦天城律师事务所</div> -->
                    <div class="bottom-left-text3">©2022 qinliannet.com 勤联（上海勤联物联网有限公司）版权所有</div>
                </div>
            </div>
            <div class="bottom-right">
                <div class="bottom-right-text1">商务合作：</div>
                <div class="bottom-right-text2">gaowk@qinlianet.com</div>
                <div class="bottom-right-text3">周一至周日 09:30-18:30</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'tab',
    data(){
        return {
            tabList: [
                {
                    img: require('../../static/img/top-img1.png'),
                    text: '首页',
                    path:'/'
                },
                {
                    img: require('../../static/img/top-img2.png'),
                    text: '品牌数字化服务',
                    path:'./number'
                },
                {
                    img: require('../../static/img/top-img5.png'),
                    text: '虚拟运动社交电商',
                    path:'./virtual'
                },
                {
                    img: require('../../static/img/top-img3.png'),
                    text: '链接线下和线上',
                    path:'./linkLine'
                },
                {
                    img: require('../../static/img/top-img4.png'),
                    text: '关于我们',
                    path:'./user'
                }
            ],
            active_index: 0,
            top_img_list: [
                
            ]
        }
    },
    created(){
        localStorage.setItem('path','./')
        let index = Number(localStorage.getItem('index'))
        if(index){
            this.active_index = index
        }else{
            this.active_index = 0
        }
    },
    mounted(){
        this.handleScroll()
    },
    methods: {
        handleScroll(){
            const images = document.querySelectorAll("img");
            // 传给IntersectionObserver的回调函数
            // 在目标元素能看见时触发一次，目标元素看不见了时再触发一次
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const image = entry.target;
                        const data_src = image.getAttribute("data-src");
                        image.setAttribute("src", data_src);
                        console.log('触发')
                        // 图片被加载后取消观察
                        observer.unobserve(image);
                    }
                });
            });
            images.forEach(image => {
                observer.observe(image);
            });
        },
        changeTab(e){
            this.active_index = e
            this.$router.push(this.tabList[this.active_index].path)
            window.scrollTo(0,0);
        }
    }
}
</script>
<style scoped>
.wrapper{
    overflow-y: scroll;
}
@media only screen and (max-width: 1480px){
.top-box{
    width: 100%;
    position: relative;
}
.top-img{
    width: 100%;
}
.top-tab{
    width: 100%;
    height: 86px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
}
.top-logo{
    width: 139px;
    margin-left: 93px;
    margin-right: 74px;
}
.tab-list{
    height: 86px;
    line-height: 86px;
    font-size: 14px;
    color: #fff;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.tab-item{
    margin-right: 41px;
    cursor: pointer;
    white-space: nowrap;
}
.bottom-box{
    width: 100%;
    height: 231px;
    background: url('../../static/img/bottom-img.png') no-repeat;
    background-size: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.bottom-left{
    margin-left: 122px;
}
.bottom-left-tabs{
    color: #fff;
    font-size: 17px;
}
.bottom-left-tab-item{
    display: inline-block;
    margin-right: 23px;
    cursor: pointer;
}
.bottom-left-info{
    margin-top: 70px;
    color: #A7A9AF;
    font-size: 12px;
}

.bottom-left-info a{
    color: #A7A9AF;
    font-size: 12px;
    text-decoration: none;
    margin-right: 5px;
}
.bottom-right{
    margin-right: 151px;
    color: #fff;
}
.bottom-right-text1,.bottom-right-text3{
    font-size: 12px;
}
.bottom-right-text2{
    font-size: 25px;
    font-family: Arial;
    font-weight: bold;
    color: #FFFFFF;
    margin-top: 10px;
}
.bottom-left-text1{
    display: flex;
    align-items: center;
    white-space: nowrap;
}
.bottom-left-text1 > img{
    width: 16px;
}
}
@media only screen and (min-width: 1480px){
.top-box{
    width: 100%;
    position: relative;
}
.top-img{
    width: 100%;
}
.top-tab{
    width: 100%;
    height: 112px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
}
.top-logo{
    width: 196px;
    margin-left: 130px;
    margin-right: 100px;
}
.tab-list{
    height: 112px;
    line-height: 112px;
    font-size: 20px;
    color: #fff;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.tab-item{
    margin-right: 56px;
    cursor: pointer;
    white-space: nowrap;
}
.bottom-box{
    width: 100%;
    height: 325px;
    background: url('../../static/img/bottom-img.png') no-repeat;
    background-size: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.bottom-left{
    margin-left: 230px;
}
.bottom-left-tabs{
    color: #fff;
    font-size: 24px;
}
.bottom-left-tab-item{
    display: inline-block;
    margin-right: 30px;
    cursor: pointer;
}
.bottom-left-info{
    margin-top: 100px;
    color: #A7A9AF;
    font-size: 17px;
}
.bottom-left-info a{
    color: #A7A9AF;
    font-size: 17px;
    text-decoration: none;
    margin-right: 5px;
}
.bottom-right{
    margin-right: 100px;
    color: #fff;
}
.bottom-right-text1,.bottom-right-text3{
    font-size: 20px;
}
.bottom-right-text2{
    font-size: 35px;
    font-family: Arial;
    font-weight: bold;
    color: #FFFFFF;
    margin-top: 20px;
}
.bottom-left-text1{
    display: flex;
    align-items: center;
    white-space: nowrap;
}
.bottom-left-text1 > img{
    width: 21px;
}
}
</style>


// WEBPACK FOOTER //
// src/pages/tab.vue